export default __webpack_public_path__ + "static/media/prmotionjobs.d5524a81.jpg";